module.exports = __webpack_public_path__ + "img/yw2.f12fb0d0.jpg";